module.exports = __webpack_public_path__ + "img/insurance-logo-2.46e3bbd5.png";